// @ts-ignore
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { FooterItemTitleFragmentDoc } from './FooterItemTitle.fragment.generated';
import { FooterItemLinkListFragmentDoc } from './FooterItemLinkList.fragment.generated';
import { FooterItemTextFragmentDoc } from './FooterItemText.fragment.generated';
import { FooterItemDividerFragmentDoc } from './FooterItemDivider.fragment.generated';
import { FooterItemWorkingHoursFragmentDoc } from './FooterItemWorkingHours.fragment.generated';
export const FooterMenuItemFragmentDoc = gql`
    fragment footerMenuItem on FooterColumnItem {
  __typename
  ...footerItemTitle
  ...footerItemLinkList
  ...footerItemText
  ...footerItemDivider
  ...footerItemWorkingHours
}
    ${FooterItemTitleFragmentDoc}
${FooterItemLinkListFragmentDoc}
${FooterItemTextFragmentDoc}
${FooterItemDividerFragmentDoc}
${FooterItemWorkingHoursFragmentDoc}`;